export default "__VITE_ASSET__CyXcv7ZL__"